import * as queries from '@queries/utils';

export const fetchSuppliers = () => queries.getQuery('/api/suppliers');

export const createSuppliers = (suppliers) => queries.postQuery('/api/suppliers', suppliers);

export const updateSuppliers = (suppliers) => queries.putQuery(`/api/suppliers`, suppliers);

export const deleteSuppliers = (suppliersToDelete) => queries.deleteQuery(`/api/suppliers`, suppliersToDelete);